module.exports = __webpack_public_path__ + "static/img/menu.5b98ad5.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/menu.png
// module id = 2PKr
// module chunks = 1